import React, { Suspense, lazy } from 'react';
import { ArrowRight, ChevronDown } from 'lucide-react';
import { companyInfo, stats } from '../../data/mock';

const Spline = lazy(() => import('@splinetool/react-spline'));

const HeroSection = ({ onBookDemo, onEnquiry }) => {
  return (
    <section className="min-h-screen relative bg-black grid-pattern overflow-hidden">
      {/* Content Container */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12 pt-32 pb-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center min-h-[70vh]">
          {/* Left Content */}
          <div className="space-y-8 animate-fade-in-up">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-white/5 border border-white/10 px-4 py-2">
              <span className="w-2 h-2 bg-[#06B6D4] rounded-full animate-pulse-slow"></span>
              <span className="text-white/70 text-sm">Technology Consultancy</span>
            </div>

            {/* Main Heading */}
            <h1 className="text-5xl lg:text-7xl font-semibold text-white leading-tight">
              {companyInfo.tagline.split(' ').slice(0, 2).join(' ')}
              <br />
              <span className="text-[#06B6D4]">
                {companyInfo.tagline.split(' ').slice(2).join(' ')}
              </span>
            </h1>

            {/* Description */}
            <p className="text-xl text-white/70 max-w-lg leading-relaxed">
              {companyInfo.description}
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-4 pt-4">
              <button onClick={onBookDemo} className="btn-primary">
                Book a Demo
                <ArrowRight className="w-5 h-5" />
              </button>
              <button onClick={onEnquiry} className="btn-secondary">
                Send Enquiry
              </button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 pt-8 border-t border-white/10">
              {stats.map((stat, index) => (
                <div key={index} className="space-y-1">
                  <div className="text-3xl font-semibold text-[#06B6D4]">{stat.value}</div>
                  <div className="text-sm text-white/50">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right - 3D Spline */}
          <div className="hidden lg:block relative">
            <div className="w-full h-[600px] overflow-visible relative">
              <Suspense fallback={
                <div className="w-full h-full flex items-center justify-center">
                  <div className="w-16 h-16 border-2 border-[#06B6D4] border-t-transparent rounded-full animate-spin"></div>
                </div>
              }>
                <Spline scene="https://prod.spline.design/NbVmy6DPLhY-5Lvg/scene.splinecode" />
              </Suspense>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <a href="#services" className="text-white/30 hover:text-[#06B6D4] transition-colors">
          <ChevronDown className="w-8 h-8" />
        </a>
      </div>
    </section>
  );
};

export default HeroSection;
